module.exports = __webpack_public_path__ + "img/img-48.8c95c618.png";